import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Card,
} from 'antd';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import { onError } from 'utils/handlers';
import { getPermisos } from 'api/usuarios/permission';
import {
  deleteGrupo,
  getGrupos,
  patchGrupo,
  postGrupo,
} from 'api/catalogos/grupos';
import Permisos from 'components/Permisos';
import usePermissionMessage from 'hooks/usePermissionMessage';

export const permissionConfig = {
  permissionModel: 'group',
  catalogsModels: ['permission'],
};

// eslint-disable-next-line react/prop-types
const Roles = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  usePermissionMessage(permission);

  const fetchData = async () => {
    setLoading(true);
    const _grupos = await getGrupos();
    setData(_grupos);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const _data = await getGrupos();
      await getPermisos();
      if (mounted) {
        setData(_data);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
    setSelectedRowKeys([]);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      const saved = await (key ? patchGrupo(key, values) : postGrupo(values));
      if (saved) {
        onCancel();
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const deleteItem = async () => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const deleted = await deleteGrupo(key);
    if (deleted) {
      onCancel();
      setVisibleAlert(false);
      await fetchData();
    }
    setLoading(true);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickEdit = () => setVisible(true);

  const onClickDelete = () => setVisibleAlert(true);

  const rules = { required: [{ required: true }] };

  const columns = [
    {
      titleText: 'Rol',
      dataIndex: 'name',
      key: 'name',
      width: '100%',
    },
  ];

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!visible
          ? (
            <Table
              cols={columns}
              mobileCols={columns}
              data={data.sort((a, b) => a.name - b.name)}
              rowSelection={rowSelection}
              handleOnRowClick={handleOnRowClick}
              controls={{
                onClickAdd,
                onClickEdit,
                onClickDelete,
              }}
              permission={permission}
            />
          )
          : (
            <Card
              className="form-container"
              title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Rol`}
              extra={(
                <FormSubmitControls
                  onFinish={onFinish}
                  onCancel={onCancel}
                  permission={permission}
                />
              )}
              bordered={false}
            >
              <Form
                layout="vertical"
                form={form}
                onFinish={() => onFinish()}
                scrollToFirstError
                initialValues={{ permissions: [] }}
              >
                <Row>
                  <Col span={24}>
                    <Form.Item
                      name="name"
                      rules={rules.required}
                      label="Nombre"
                      hasFeedback
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Permisos formItemName="permissions" />
                  <Form.Item hidden>
                    <Button htmlType="submit" />
                  </Form.Item>
                </Row>
              </Form>
            </Card>
          )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          visible={visibleAlert}
          content={`Rol ${form.getFieldValue('name')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default Roles;
